module.exports = __webpack_public_path__ + "static/media/Novarese_BookItalic.056dca98.svg";